import classNames from 'classnames';
import { navigate } from 'gatsby';
import { GatsbyImage } from "gatsby-plugin-image";
import React from 'react';

import Button, { themes, sizes } from '../UI/Button/Button';
import * as styles from './Promotion.module.scss';

const Promotion = ({ title, link, summary, image }) => {
  const classname = classNames(styles.promotion);
  const titlePlain = title?.replace(/\*\*(\S[^*]+\S)\*\*/g, '$1');

  return (
    <article className={classname} onClick={e => navigate(link?.url)}>
      <div className={styles.body}>
        <h3 className={styles.title}>{titlePlain}</h3>
        <p className={styles.summary}>{summary}</p>
        <Button
          to={link?.url}
          theme={themes.LINK}
          isReverse
          isCard
          size={sizes.LARGE}
        >
          Learn more
        </Button>
      </div>
      <GatsbyImage
        image={image?.localFile?.small?.gatsbyImageData}
        className={styles.image} />
    </article>
  );
};

export { Promotion as default };
